import Error from '.Error';
import TypeError from '.TypeError';

import * as options from './options';
import * as is from './is';
import * as TOKEN from './TOKEN';
import Layer, { protect } from './Layer';
import Url, { newUrl } from './Url';
import AttributeSelector from './AttributeSelector';
import Parenthesis from './Parenthesis';
import Descriptor from './Declaration';
import StyleRule from './StyleRule';
import KeyframesRule from './@keyframes';

export class DeclarationList extends Layer                                                  {
	
	get [Symbol.toStringTag] () { return 'AtRule.DeclarationList'; }
	
	                 _noAt         ;
	                 _canQualified         ;
	                 _noDescriptor         ;
	
	constructor (parent        , could                                                                           ) {
		super();
		this[TOKEN.parent] = parent;
		this._noAt = !could['@'];
		this._canQualified = could['{}'];
		this._noDescriptor = !could[':;'];
		return parent.block = this;
	}
	
	[TOKEN.consume] (                     ) {
		switch ( TOKEN.type ) {
			case TOKEN.whitespace:
			case TOKEN.comment:
				return this;
			case TOKEN.atKeyword:
				if ( this._noAt ) { break; }
				const keywordLiteral = TOKEN.literal.slice(1);
				if ( is.charset (keywordLiteral) || is.import (keywordLiteral) || is.namespace (keywordLiteral) ) { break; }
				return this.newItem = new ( is.keyframes (keywordLiteral) ? KeyframesRule : AtRule )(keywordLiteral);
			case TOKEN.ident:
				if ( this._noDescriptor ) {
					if ( this._canQualified ) {
						TOKEN.stay();
						return this.newItem = new StyleRule;// may not style rule
					}
					break;
				}
				if ( this._canQualified ) {
					for ( let i = TOKEN.index; i!==TOKEN.length; ++i ) {
						switch ( TOKEN.types[i] ) {
							case '{':
								TOKEN.stay();
								return this.newItem = new StyleRule;// may not style rule
							case ';':
							case '}':
								break;
							default:
								continue;
						}
						break;
					}
				}
				return this.newItem = new Descriptor(TOKEN.literal);
			case '*':
			case '.':
			case ':':
			case '[':
			case '|':
			case TOKEN.hash:
				if ( this._canQualified ) {
					TOKEN.stay();
					return this.newItem = new StyleRule;
				}
				break;
			case '}':
				return this[TOKEN.parent][TOKEN.parent];
		}
		return null;
	}
	
	[Symbol.toPrimitive] (                     ) { return this.join(''); }
	
	* [Symbol.iterator] (                     ) { throw TypeError(`beautify declarationList`); }
	
	                               
	
	static default = protect(this);
	
}

export default class AtRule extends Layer                                                 {
	
	get [Symbol.toStringTag] () { return 'AtRule'; }
	
	         keywordLiteral        ;
	block                         = null;
	
	constructor (keywordLiteral        ) {
		//if ( !keywordLiteral ) { throw SyntaxError(`At Rule 不能为 @`); }
		super();
		this.keywordLiteral = keywordLiteral;
		if ( is.media (keywordLiteral) ) { new DeclarationList(this, { '@': true, '{}': true, ':;': false }); }
		//else if ( is.keyframes(keywordLiteral) ) { new DeclarationList(this, { '@': false, '{}': true, ':;': false }); }
		else if ( is.page (keywordLiteral) ) { new DeclarationList(this, { '@': true, '{}': false, ':;': true }); }
		else if ( is.font_face (keywordLiteral) || is.counter_style (keywordLiteral) ) { new DeclarationList(this, { '@': false, '{}': false, ':;': true }); }
		else if ( is.supports (keywordLiteral) || is.document (keywordLiteral) ) { new DeclarationList(this, { '@': true, '{}': true, ':;': false }); }///
		else if ( is.viewport (keywordLiteral) ) { throw Error(`@${keywordLiteral} 已经废弃`); }
		else if ( this[TOKEN.parent].constructor===DeclarationList && is.page (( this[TOKEN.parent][TOKEN.parent]           ).keywordLiteral) ) { new DeclarationList(this, { '@': false, '{}': false, ':;': true }); }
		return this;
	}
	
	[TOKEN.consume] (            ) {
		switch ( TOKEN.type ) {
			case TOKEN.whitespace:
				this.length && ( this.newItem = ' ' );
				return this;
			case TOKEN.function_:
				return this.newItem = new ( is.url_ (TOKEN.literal) ? Url : Parenthesis )(TOKEN.literal.slice(0, -1));
			case '(':
				return this.newItem = new Parenthesis;
			case TOKEN.ident:
			case TOKEN.string:
			case ':':
			case ',':
				this.newItem = TOKEN.literal;
				return this;
			case TOKEN.url:
				if ( TOKEN.literal[3]==='(' || is.document (this.keywordLiteral) ) { return newUrl(this); }
				break;
			case '{': {
				//if ( is.charset(this.keywordLiteral) || is.import(this.keywordLiteral) || is.namespace(this.keywordLiteral) ) { break; }
				const { lastIndex } = this;
				if ( lastIndex>=0 ) {
					const lastItem = this[lastIndex];
					if ( lastItem===' ' || lastItem==='/**/' ) { this.length = lastIndex; }
				}
				return this.block ?? ( this.block = new DeclarationList(this, { '@': true, '{}': true, ':;': true }) );
			}
			case ';':
				if ( this.block ) { break; }
				return this[TOKEN.parent];
			case '}':
				if ( this.block ) { break; }
				TOKEN.stay();
				return this[TOKEN.parent];
			case TOKEN.comment:
				this.length && ( this.newItem = '/**/' );
				return this;
		}
		return null;
	}
	
	[Symbol.toPrimitive] (            ) {
		const { block } = this;
		if ( block ) {
			const blockText = '' + block;
			return `@${this.keywordLiteral}${this.length ? ' ' : ''}${this.join('')}{${blockText && blockText[blockText.length - 1]===';' ? blockText.slice(0, -1) : blockText}}`;
		}
		else {
			return `@${this.keywordLiteral}${this.length ? ' ' : ''}${this.join('')};`;
		}
	}
	
	* [Symbol.iterator] (            )                                {
		const { block } = this;
		if ( block ) {
			const { length } = block;
			if ( length ) {
				yield `@${this.keywordLiteral}${this.length ? ' ' : ''}${this.join('')} {`;
				let index = 0;
				while ( index!==length ) {
					for ( const line of block[index++]  ) {
						yield options.indent + line;
					}
				}
				yield `}`;
			}
			else { yield `@${this.keywordLiteral}${this.length ? ' ' : ''}${this.join('')} { }`; }
		}
		else {
			yield `@${this.keywordLiteral}${this.length ? ' ' : ''}${this.join('')};`;
		}
	}
	
	                                                
	
	static default = protect(this);
	
};

                                 